import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import emailjs from "emailjs-com";

function AdminNewsletter() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [messageForm, setMessageForm] = useState({ subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const fetchSubscribers = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("newsletter_subscriptions")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) {
      console.error(error);
      setSubscribers([]);
    } else {
      setSubscribers(data || []);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const handleChange = (e) => {
    setMessageForm({ ...messageForm, [e.target.name]: e.target.value });
  };

  const handleSendNewsletter = async (e) => {
    e.preventDefault();
    if (!messageForm.subject || !messageForm.message) {
      setError("Veuillez remplir le sujet et le message");
      return;
    }

    setSending(true);
    setSuccess("");
    setError("");

    try {
      for (let sub of subscribers) {
        await emailjs.send(
          "service_3bhpda9", 
          "template_4o0bxyi", 
          {
            to_email: sub.email,
            subject: messageForm.subject,
            message: messageForm.message,
          },
          "L-loHFaGtckwBdRJE" 
        );
        await new Promise((res) => setTimeout(res, 200)); 
      }
      setSuccess(`✅ Message envoyé à ${subscribers.length} abonnés !`);
      setMessageForm({ subject: "", message: "" });
    } catch (err) {
      console.error(err);
      setError("❌ Erreur lors de l'envoi");
    } finally {
      setSending(false);
    }
  };

  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const currentSubscribers = subscribers.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(subscribers.length / perPage);

  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) return <p>Chargement...</p>;

  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3 className="page-title">Gestion Newsletter</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item" style={{ color: "#0063cc" }}>Tables</li>
            <li className="breadcrumb-item active" aria-current="page">Abonnés</li>
          </ol>
        </nav>
      </div>

      {/* Formulaire d'envoi newsletter */}
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Envoyer un message à tous les abonnés</h4>
              <form onSubmit={handleSendNewsletter}>
                <div className="form-group">
                  <label>Sujet</label>
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    value={messageForm.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Message</label>
                  <textarea
                    className="form-control"
                    name="message"
                    value={messageForm.message}
                    onChange={handleChange}
                    rows="5"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary" disabled={sending}>
                  {sending ? "Envoi..." : "Envoyer"}
                </button>
                {error && <div className="alert alert-danger mt-3">{error}</div>}
                {success && <div className="alert alert-success mt-3">{success}</div>}
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Liste des abonnés */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Liste des abonnés</h4>
              <div className="table-responsive custom-scroll">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Date d'inscription</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentSubscribers.length === 0 ? (
                      <tr>
                        <td colSpan="2" className="text-center">Aucun abonné trouvé.</td>
                      </tr>
                    ) : (
                      currentSubscribers.map((sub) => (
                        <tr key={sub.id}>
                          <td>{sub.email}</td>
                          <td>{new Date(sub.created_at).toLocaleString()}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {subscribers.length > 0 && (
                <nav aria-label="Page navigation" className="mt-3">
                  <ul className="pagination justify-content-center">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={goToPreviousPage}>&laquo;</button>
                    </li>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                      <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                        <button className="page-link" onClick={() => paginate(page)}>{page}</button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={goToNextPage}>&raquo;</button>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminNewsletter;
